import {logger} from '../helperFunctions';

const useHandleApi = ({setLoading, authAndContent, account}) => {
  const handleApiCallWithToken = async (api, ...args) => {
    setLoading(true);
    const newToken = await authAndContent.getValidToken();
    const res = await api(newToken, ...args);

    setLoading(false);
    if (res?.errors) {
      logger(`${api.name} failed:`);
      logger(res);
    }
    return res;
  };

  const handleApiRes = ({
    res,
    successMsg,
    errorMsg,
    reloadAccount = true,
    callback = null
  }) => {
    if (res?.errors && errorMsg) {
      authAndContent.showError(res.errors, errorMsg);
    }
    if (!res?.errors && successMsg) {
      authAndContent.setSnackBarMessage(successMsg);
    }

    if (reloadAccount) {
      account.fetchAccount(true);
    }

    if (callback) {
      return callback(res);
    }
    return res;
  };

  return [handleApiCallWithToken, handleApiRes];
};

export default useHandleApi;
